import { useState, useEffect, useRef, useCallback } from 'react';
import { useLang } from '../context/LanguageContext';
import en from '../lang/en';
import de from '../lang/de';
import it from '../lang/it';
import fr from '../lang/fr';
import { homeVideo } from '../assets/media';

function HeroContent({ phase }) {
  return (
    <div className="hero-content">
      <div className="hero-titles">
        <h1>
          {phase.h1Before}
          <span className="pink-highlight">{phase.h1Highlight}</span>
          {phase.h1After}
        </h1>
        <h3>{phase.h3}</h3>
      </div>
      <div className="flex-grid">
        {phase.cols.map((col, i) => (
          <div key={i} className={`styled-col ${col.border} d${i + 1}`}>
            {col.lines[0]}<br />{col.lines[1]}
          </div>
        ))}
      </div>
    </div>
  );
}

function Home() {
  const { lang } = useLang();
  const phases = lang === 'de' ? de.home.phases : lang === 'it' ? it.home.phases : lang === 'fr' ? fr.home.phases : en.home.phases;
  const [currentIdx, setCurrentIdx] = useState(0);
  const [isExiting, setIsExiting] = useState(false);
  const [renderKey, setRenderKey] = useState(0);
  const timerRef = useRef(null);
  const videoRef = useRef(null);

  const handleVideoRef = useCallback((node) => {
    if (node) {
      node.playbackRate = 0.5;
      videoRef.current = node;
    }
  }, []);

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      setIsExiting(true);
      setTimeout(() => {
        setIsExiting(false);
        setCurrentIdx(prev => (prev + 1) % phases.length);
        setRenderKey(prev => prev + 1);
      }, 600);
    }, 7500);
    return () => clearTimeout(timerRef.current);
  }, [renderKey]);

  return (
    <section className="hero">
      <video ref={handleVideoRef} className="hero-video" src={homeVideo} autoPlay loop muted playsInline />
      <div className="hero-video-overlay"></div>
      <div className="hero-bg-circles">
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
        <div className="circle circle-3"></div>
      </div>
      <div className={`hero-loop${isExiting ? ' exit-anim' : ''}`} key={renderKey}>
        <HeroContent phase={phases[currentIdx]} />
      </div>
    </section>
  );
}

export default Home;
